import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { getStyle } from '../../../utils/utils';
import CBMediaQuery from '../../shared/CBMediaQuery';
import CBHeaderTextWithHelp from '../../shared/CBHeaderTextWithHelp';
import CBButtonWithIconSmall from '../../shared/CBButtonWithIconSmall';
import CBSearchInput from '../../shared/CBSearchInput';
import CBInputField from '../../shared/form_components/CBInputField';
import CBSubmitButton from '../../shared/form_components/CBSubmitButton';
import CBSelectField from '../../shared/form_components/CBSelectField';
import CBButtonSettings from '../../shared/CBButtonSettings';
import CBLabelAndCheckbox from '../../shared/CBLabelAndCheckbox';
import CBPromptModal from '../../shared/CBPromptModal';
import {
  getLengthValidator,
} from '../../../utils/validators';
import {
  fetchChains as _fetchChains,
  fetchChain as _fetchChain,
  createChain as _createChain,
  updateChain as _updateChain,
  deleteChain as _deleteChain,
  fetchChainMemberships as _fetchChainMemberships,
  createChainMembership as _createChainMembership,
  updateChainMembership as _updateChainMembership,
  deleteChainMembership as _deleteChainMembership,
  createChainPermission as _createChainPermission,
} from '../../../actions/chainActions';
import {
  fetchWorkshops as _fetchWorkshops,
} from '../../../actions/workshopActions';

const VEHICLE_TYPE_OPTIONS = [
  { label: 'Kaikki ajoneuvot', value: 'all' },
  { label: 'Kevyet ajoneuvot', value: 'light' },
  { label: 'Raskaat ajoneuvot', value: 'heavy' },
];

class StaffSettingsChains extends React.Component {
  state = {
    selectedChain: null,
    formData: null,
    formValid: {},
    search: '',
    deleteModalIsOpen: false,
    deleteMembershipModalIsOpen: false,
    membershipToDelete: null,
    newMembershipWorkshopId: '',
    newMembershipVehicleType: 'all',
    newMembershipHasCareServiceDeal: true,
    pendingDetailFetchId: null,
    pendingAdminEmail: null,
    pendingChainCreate: false,
  };

  componentDidMount() {
    const { fetchChains, fetchWorkshops } = this.props;
    fetchChains();
    fetchWorkshops({ ordering: 'name' });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.chains === this.props.chains) return;
    if (!this.state.pendingDetailFetchId) return;

    var updated = this.props.chains.find(function (c) { return c.id === this.state.pendingDetailFetchId; }.bind(this));
    if (updated && updated.email !== undefined) {
      this.setState({
        selectedChain: updated,
        formData: Object.assign({}, updated),
        pendingDetailFetchId: null,
      });
    }

    if (this.state.pendingChainCreate && this.props.chains.length > prevProps.chains.length) {
      var newChain = this.props.chains[this.props.chains.length - 1];
      if (newChain && newChain.id && this.state.pendingAdminEmail) {
        this.props.createChainPermission({
          chain: newChain.id,
          user_email: this.state.pendingAdminEmail,
          role: 'admin',
        });
      }
      this.setState({
        pendingChainCreate: false,
        pendingAdminEmail: null,
        selectedChain: newChain,
        formData: Object.assign({}, newChain),
        pendingDetailFetchId: newChain ? newChain.id : null,
      });
      if (newChain && newChain.id) {
        this.props.fetchChain(newChain.id);
        this.props.fetchChainMemberships(newChain.id);
      }
    }
  }

  selectChain = (chain) => {
    const { fetchChain, fetchChainMemberships } = this.props;
    this.setState({
      selectedChain: chain,
      formData: Object.assign({}, chain),
      formValid: {},
      pendingDetailFetchId: chain && chain.id ? chain.id : null,
    });
    if (chain && chain.id) {
      fetchChain(chain.id);
      fetchChainMemberships(chain.id);
    }
  };

  createNewChain = () => {
    const newChain = {
      name: '',
      business_id: '',
      street_address: '',
      zip_code: '',
      city: '',
      email: '',
      phone_number: '',
      contact_name: '',
      contact_phone_number: '',
      chain_type: 'parts_vendor',
      show_maintenance_prices: true,
      use_consolidated_invoicing: false,
      block_external_writes: false,
      admin_email: '',
    };
    this.setState({
      selectedChain: newChain,
      formData: Object.assign({}, newChain),
      formValid: {},
    });
  };

  newChainCreated = () => this.setState({ selectedChain: null, formData: null });

  updateFormState = (changedObject) => {
    const { formData } = this.state;
    const newFormData = Object.assign({}, formData);
    newFormData[changedObject.target] = changedObject.value;
    this.setState({ formData: newFormData });
  };

  setIsValid = (name, isValid) => {
    const { formValid } = this.state;
    const newFormValid = { ...formValid };
    newFormValid[name] = isValid;
    this.setState({ formValid: newFormValid });
  };

  getIsValid = () => {
    const { formValid } = this.state;
    let isValid = true;
    Object.values(formValid).forEach(fieldIsValid => {
      if (!fieldIsValid) {
        isValid = false;
      }
    });
    return isValid;
  };

  submitForm = () => {
    const { createChain, updateChain } = this.props;
    const { formData, selectedChain } = this.state;

    if (selectedChain && selectedChain.id) {
      updateChain(selectedChain.id, formData);
    } else {
      var adminEmail = formData.admin_email;
      var chainData = Object.assign({}, formData);
      delete chainData.admin_email;
      this.setState({
        pendingChainCreate: true,
        pendingAdminEmail: adminEmail || null,
      });
      createChain(chainData);
    }
  };

  handleDelete = () => {
    const { deleteChain } = this.props;
    const { selectedChain } = this.state;
    if (selectedChain && selectedChain.id) {
      deleteChain(selectedChain.id);
      this.setState({
        selectedChain: null,
        formData: null,
        deleteModalIsOpen: false,
      });
    }
  };

  changeSearchTerms = (value) => {
    this.setState({ search: value });
  };

  fetchWithSearch = () => {
    const { fetchChains } = this.props;
    const { search } = this.state;
    fetchChains({ search });
  };

  addMembership = () => {
    const { createChainMembership } = this.props;
    const { selectedChain, newMembershipWorkshopId, newMembershipVehicleType, newMembershipHasCareServiceDeal } = this.state;
    if (selectedChain && selectedChain.id && newMembershipWorkshopId) {
      createChainMembership({
        chain: selectedChain.id,
        workshop_id: parseInt(newMembershipWorkshopId, 10),
        vehicle_type_access: newMembershipVehicleType,
        has_chain_care_service_deal: newMembershipHasCareServiceDeal,
      });
      this.setState({ newMembershipWorkshopId: '' });
    }
  };

  handleDeleteMembership = () => {
    const { deleteChainMembership } = this.props;
    const { membershipToDelete } = this.state;
    if (membershipToDelete) {
      deleteChainMembership(membershipToDelete.id);
      this.setState({ deleteMembershipModalIsOpen: false, membershipToDelete: null });
    }
  };

  updateMembershipField = (membershipId, field, value) => {
    const { updateChainMembership, chainMemberships } = this.props;
    const membership = chainMemberships.find(m => m.id === membershipId);
    if (membership) {
      const data = {
        chain: membership.chain,
        workshop_id: membership.workshop.id,
        vehicle_type_access: membership.vehicle_type_access,
        has_chain_care_service_deal: membership.has_chain_care_service_deal,
      };
      data[field] = value;
      updateChainMembership(membershipId, data);
    }
  };

  getWorkshopOptions = () => {
    const { workshops, chainMemberships, t } = this.props;
    const memberWorkshopIds = (chainMemberships || []).map(m => m.workshop && m.workshop.id);
    const placeholder = { label: t('selectWorkshop'), value: '' };
    const workshopOptions = workshops
      .filter(ws => !memberWorkshopIds.includes(ws.id))
      .map(ws => ({
        label: ws.name,
        value: ws.id,
      }));
    return [placeholder, ...workshopOptions];
  };

  render() {
    const { t, chains, chainMemberships, chainsStatus } = this.props;
    const {
      selectedChain, formData, deleteModalIsOpen,
      deleteMembershipModalIsOpen,
      newMembershipWorkshopId, newMembershipVehicleType, newMembershipHasCareServiceDeal,
    } = this.state;

    const isEditing = selectedChain && selectedChain.id;

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <div style={getStyle(screenSize, styles, 'editChainContainer')}>
              <CBHeaderTextWithHelp text={t('chainFormHeading')} />
              {
                !selectedChain && (
                  <CBButtonWithIconSmall
                    icon='/img/icon_plus.svg'
                    text={t('addChainButton')}
                    onClick={this.createNewChain}
                  />
                )
              }
              {formData && (
                <div style={styles.formContainer}>
                  <CBInputField
                    labelText={t('chainName')}
                    name='name'
                    onChange={this.updateFormState}
                    value={formData.name}
                    isValidCallback={this.setIsValid}
                    validators={[getLengthValidator(2, 255)]}
                    labelTextStyle={styles.fieldContainerLeftAlign}
                  />
                  <CBInputField
                    labelText={t('businessIdLabel')}
                    name='business_id'
                    onChange={this.updateFormState}
                    value={formData.business_id}
                    isValidCallback={this.setIsValid}
                    validators={[getLengthValidator(9, 9)]}
                    labelTextStyle={styles.fieldContainerLeftAlign}
                  />
                  <CBInputField
                    labelText={t('addressLabel')}
                    name='street_address'
                    onChange={this.updateFormState}
                    value={formData.street_address}
                    isValidCallback={this.setIsValid}
                    validators={[]}
                    labelTextStyle={styles.fieldContainerLeftAlign}
                  />
                  <CBInputField
                    labelText={t('zipCodeLabel')}
                    name='zip_code'
                    onChange={this.updateFormState}
                    value={formData.zip_code}
                    isValidCallback={this.setIsValid}
                    validators={[]}
                    labelTextStyle={styles.fieldContainerLeftAlign}
                  />
                  <CBInputField
                    labelText={t('cityLabel')}
                    name='city'
                    onChange={this.updateFormState}
                    value={formData.city}
                    isValidCallback={this.setIsValid}
                    validators={[]}
                    labelTextStyle={styles.fieldContainerLeftAlign}
                  />
                  <CBInputField
                    labelText={t('emailLabel')}
                    name='email'
                    onChange={this.updateFormState}
                    value={formData.email}
                    isValidCallback={this.setIsValid}
                    validators={[]}
                    labelTextStyle={styles.fieldContainerLeftAlign}
                  />
                  <CBInputField
                    labelText={t('phoneNumberLabel')}
                    name='phone_number'
                    onChange={this.updateFormState}
                    value={formData.phone_number}
                    isValidCallback={this.setIsValid}
                    validators={[]}
                    labelTextStyle={styles.fieldContainerLeftAlign}
                  />
                  <CBInputField
                    labelText={t('contactNameLabel')}
                    name='contact_name'
                    onChange={this.updateFormState}
                    value={formData.contact_name}
                    isValidCallback={this.setIsValid}
                    validators={[]}
                    labelTextStyle={styles.fieldContainerLeftAlign}
                  />
                  <CBInputField
                    labelText={t('contactPhoneNumberLabel')}
                    name='contact_phone_number'
                    onChange={this.updateFormState}
                    value={formData.contact_phone_number}
                    isValidCallback={this.setIsValid}
                    validators={[]}
                    labelTextStyle={styles.fieldContainerLeftAlign}
                  />

                  {!isEditing && (
                    <CBInputField
                      labelText={t('adminEmail')}
                      name='admin_email'
                      onChange={this.updateFormState}
                      value={formData.admin_email || ''}
                      isValidCallback={this.setIsValid}
                      validators={[]}
                      labelTextStyle={styles.fieldContainerLeftAlign}
                    />
                  )}

                  <CBSelectField
                    containerStyle={styles.fieldContainerLeftAlign}
                    optionStyle={styles.optionStyle}
                    value={formData.chain_type || 'parts_vendor'}
                    options={[
                      { value: 'parts_vendor', label: t('chainTypeParts') },
                      { value: 'other', label: t('chainTypeOther') },
                    ]}
                    onChange={(opt) => this.updateFormState({ target: 'chain_type', value: opt.value })}
                    labelText={t('chainTypeLabel')}
                  />
                  <CBLabelAndCheckbox
                    checked={formData.show_maintenance_prices !== false}
                    labelText={t('showMaintenancePrices')}
                    color='white'
                    onChange={() => this.updateFormState({ target: 'show_maintenance_prices', value: !formData.show_maintenance_prices })}
                  />
                  <CBLabelAndCheckbox
                    checked={!!formData.use_consolidated_invoicing}
                    labelText={t('useConsolidatedInvoicing')}
                    color='white'
                    onChange={() => this.updateFormState({ target: 'use_consolidated_invoicing', value: !formData.use_consolidated_invoicing })}
                  />
                  <CBLabelAndCheckbox
                    checked={!!formData.block_external_writes}
                    labelText={t('blockExternalWrites')}
                    color='white'
                    onChange={() => this.updateFormState({ target: 'block_external_writes', value: !formData.block_external_writes })}
                  />

                  <CBSubmitButton
                    disabled={chainsStatus.loading || !this.getIsValid()}
                    onClick={this.submitForm}
                  />

                  {isEditing && (
                    <div style={{ marginTop: 16 }}>
                      <CBButtonSettings
                        text={t('deleteChainButton')}
                        onClick={() => this.setState({ deleteModalIsOpen: true })}
                      />
                    </div>
                  )}
                </div>
              )}

              {isEditing && (
                <div style={styles.membershipSection}>
                  <CBHeaderTextWithHelp text={t('chainMembershipsHeading')} />

                  {chainMemberships && chainMemberships.length > 0 && (
                    <table style={styles.membershipTable}>
                      <thead>
                        <tr>
                          <th style={styles.membershipTableHeading}>{t('workshopNameLabel')}</th>
                          <th style={styles.membershipTableHeading}>{t('vehicleTypeAccess')}</th>
                          <th style={styles.membershipTableHeading}>{t('hasCareServiceDeal')}</th>
                          <th style={styles.membershipTableHeading}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {chainMemberships.map(membership => (
                          <tr key={membership.id}>
                            <td style={styles.membershipTd}>
                              {membership.workshop && membership.workshop.name}
                            </td>
                            <td style={styles.membershipTd}>
                              <CBSelectField
                                optionStyle={styles.optionStyle}
                                value={membership.vehicle_type_access}
                                options={VEHICLE_TYPE_OPTIONS}
                                onChange={(opt) => this.updateMembershipField(membership.id, 'vehicle_type_access', opt.value)}
                              />
                            </td>
                            <td style={styles.membershipTd}>
                              <CBLabelAndCheckbox
                                checked={membership.has_chain_care_service_deal}
                                labelText=''
                                color='white'
                                onChange={() => this.updateMembershipField(
                                  membership.id,
                                  'has_chain_care_service_deal',
                                  !membership.has_chain_care_service_deal
                                )}
                              />
                            </td>
                            <td style={styles.membershipTd}>
                              <CBButtonSettings
                                text={t('removeMembership')}
                                onClick={() => this.setState({
                                  deleteMembershipModalIsOpen: true,
                                  membershipToDelete: membership,
                                })}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}

                  <div style={styles.addMembershipContainer}>
                    <p style={styles.addMembershipLabel}>{t('addMembershipHeading')}</p>
                    <div style={styles.addMembershipRow}>
                      <CBSelectField
                        containerStyle={styles.addMembershipField}
                        optionStyle={styles.optionStyle}
                        value={newMembershipWorkshopId}
                        options={this.getWorkshopOptions()}
                        onChange={(opt) => this.setState({ newMembershipWorkshopId: opt.value })}
                        placeholder={t('selectWorkshop')}
                        labelText={t('workshopNameLabel')}
                      />
                      <CBSelectField
                        containerStyle={styles.addMembershipField}
                        optionStyle={styles.optionStyle}
                        value={newMembershipVehicleType}
                        options={VEHICLE_TYPE_OPTIONS}
                        onChange={(opt) => this.setState({ newMembershipVehicleType: opt.value })}
                        labelText={t('vehicleTypeAccess')}
                      />
                      <CBLabelAndCheckbox
                        checked={newMembershipHasCareServiceDeal}
                        labelText={t('hasCareServiceDeal')}
                        color='white'
                        onChange={() => this.setState(prev => ({
                          newMembershipHasCareServiceDeal: !prev.newMembershipHasCareServiceDeal,
                        }))}
                      />
                      <CBButtonWithIconSmall
                        icon='/img/icon_plus.svg'
                        text={t('addMembership')}
                        onClick={this.addMembership}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div style={getStyle(screenSize, styles, 'searchChainContainer')}>
              <CBHeaderTextWithHelp text={t('chainsSearchHeading')} />
              <div>
                <div style={getStyle(screenSize, styles, 'searchInputContainer')}>
                  <CBSearchInput
                    containerStyle={{ marginLeft: 0 }}
                    changeSearchTerms={this.changeSearchTerms}
                    onBlur={this.fetchWithSearch}
                  />
                </div>
                <div>
                  <table style={getStyle(screenSize, styles, 'table')}>
                    <thead>
                      <tr>
                        {
                          screenSize === 'large' && (
                            <th style={getStyle(screenSize, styles, 'tableHeader')}>Id</th>
                          )
                        }
                        <th style={getStyle(screenSize, styles, 'tableHeader')}>{t('chainName')}</th>
                        <th style={getStyle(screenSize, styles, 'tableHeader')}>{t('businessIdLabel')}</th>
                        <th style={getStyle(screenSize, styles, 'tableHeader')}>{t('cityLabel')}</th>
                        <th style={getStyle(screenSize, styles, 'tableHeader')} />
                      </tr>
                    </thead>
                    <tbody>
                      {chains.map(chain => (
                        <tr key={chain.id}>
                          {
                            screenSize === 'large' && (
                              <td style={getStyle(screenSize, styles, 'tableValueText')}>{chain.id}</td>
                            )
                          }
                          <td style={getStyle(screenSize, styles, 'tableValueText')}>{chain.name}</td>
                          <td style={getStyle(screenSize, styles, 'tableValueText')}>{chain.business_id}</td>
                          <td style={getStyle(screenSize, styles, 'tableValueText')}>{chain.city}</td>
                          <td style={getStyle(screenSize, styles, 'tableValueText')}>
                            <img
                              alt='Edit'
                              src='/img/icon_edit.svg'
                              style={getStyle(screenSize, styles, 'editButton')}
                              onClick={() => this.selectChain(chain)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <CBPromptModal
              modalIsOpen={deleteModalIsOpen}
              closeModal={() => this.setState({ deleteModalIsOpen: false })}
              afterOpenModal={() => {}}
              title={t('deleteChainTitle')}
              text={t('deleteChainText')}
              buttonText={t('deleteChainConfirm')}
              performAction={this.handleDelete}
            />

            <CBPromptModal
              modalIsOpen={deleteMembershipModalIsOpen}
              closeModal={() => this.setState({ deleteMembershipModalIsOpen: false })}
              afterOpenModal={() => {}}
              title={t('deleteMembershipTitle')}
              text={t('deleteMembershipText')}
              buttonText={t('deleteMembershipConfirm')}
              performAction={this.handleDeleteMembership}
            />
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      display: 'flex',
      paddingBottom: 50,
    },
    editChainContainer: {
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 20,
      width: '40%',
      borderRight: '1px solid rgba(255, 255, 255, 0.4)',
      minHeight: 500,
    },
    searchChainContainer: {
      width: '60%',
      padding: 20,
      paddingLeft: 20,
      paddingRight: 20,
    },
    searchInputContainer: {
      marginBottom: 16,
      maxWidth: 400,
    },
    table: {
      width: '100%',
    },
    tableHeader: {
      fontFamily: 'TitilliumWeb-Light',
      color: '#FFFFFF',
    },
    tableValueText: {
      fontFamily: 'TitilliumWeb-Light',
      fontSize: 18,
      color: '#FFFFFF',
    },
    editButton: {
      cursor: 'pointer',
      width: 20,
      height: 20,
    },
  },
  medium: {
    container: {
      paddingBottom: 25,
    },
    editChainContainer: {
      paddingLeft: 0,
      paddingRight: 15,
      paddingTop: 15,
    },
    searchChainContainer: {
      padding: 15,
      paddingLeft: 15,
      paddingRight: 0,
    },
  },
  small: {
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    editChainContainer: {
      paddingLeft: 0,
      paddingRight: 0,
      width: '100%',
      borderRight: 0,
      marginBottom: 20,
      minHeight: 0,
    },
    searchChainContainer: {
      width: '100%',
      paddingLeft: 0,
      paddingRight: 0,
      marginBottom: 20,
    },
  },
  formContainer: {
    position: 'relative',
  },
  fieldContainerLeftAlign: {
    marginBottom: 5,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: '100%',
  },
  membershipSection: {
    marginTop: 40,
    borderTop: '1px solid rgba(255, 255, 255, 0.4)',
    paddingTop: 20,
  },
  membershipTable: {
    width: '100%',
    marginTop: 16,
  },
  membershipTableHeading: {
    fontFamily: 'TitilliumWeb-Regular',
    fontSize: 12,
    color: '#ffffff',
    paddingLeft: 8,
    paddingBottom: 8,
    textAlign: 'left',
  },
  membershipTd: {
    border: '1px solid rgba(255, 255, 255, .3)',
    color: '#FFFFFF',
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4,
    paddingBottom: 4,
  },
  optionStyle: {
    backgroundColor: 'rgb(0, 149, 218)',
  },
  addMembershipContainer: {
    marginTop: 24,
    borderTop: '1px solid rgba(255, 255, 255, 0.2)',
    paddingTop: 16,
  },
  addMembershipLabel: {
    fontFamily: 'TitilliumWeb-SemiBold',
    fontSize: 14,
    color: '#ffffff',
    marginBottom: 12,
  },
  addMembershipRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  addMembershipField: {
    marginBottom: 0,
  },
};

function mapStateToProps(state) {
  return {
    chains: state.chain.chains,
    chainsStatus: state.chain.chainsStatus,
    chainMemberships: state.chain.chainMemberships,
    workshops: state.workshop.workshops,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchChains: _fetchChains,
    fetchChain: _fetchChain,
    createChain: _createChain,
    updateChain: _updateChain,
    deleteChain: _deleteChain,
    fetchChainMemberships: _fetchChainMemberships,
    createChainMembership: _createChainMembership,
    updateChainMembership: _updateChainMembership,
    deleteChainMembership: _deleteChainMembership,
    createChainPermission: _createChainPermission,
    fetchWorkshops: _fetchWorkshops,
  },
)(translate('SettingsView')(StaffSettingsChains));
